module.exports = __webpack_public_path__ + "img/module1.7394c00d.png";